<template>
  <div class="custom">
    <div class="custom-framework">
      <h2>系统框架</h2>
      <div class="framework-content clearfix">
        <address class="content-item">
          <img src="../../static/images/custom_mobile/wulianwang.png" />
          <h4>物联网&智能软硬<br />定制</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/custom_mobile/app.png" />
          <h4>APP<br />定制</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/custom_mobile/Web.png" />
          <h4>Web系统<br />定制</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/custom_mobile/xiaochenxu.png" />
          <h4>微信小程序<br />定制</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/custom_mobile/gongzhonghao.png" />
          <h4>微信公众号<br />定制</h4>
        </address>
        <address class="content-item">
          <img src="../../static/images/custom_mobile/qiyexitong.png" />
          <h4>企业系统<br />定制</h4>
        </address>
      </div>
    </div>
    <div class="custom-process">
      <h2>“1+10”<br/>核心产品服务体系</h2>
      <div class="swiper-container clearfix">
        <div class="swiper-wrapper">
          <address class="swiper-slide">
            <img class="img" src="../../static/images/custom_develop/1a.png" />
            <h4>IT <br />咨询</h4>
          </address>
          <address class="swiper-slide jiantou">
            <img src="../../static/images/custom_mobile/jiantou.png" />
          </address>
          <address class="swiper-slide">
            <img class="img" src="../../static/images/custom_develop/2a.png" />
            <h4>需求<br />调研</h4>
          </address>
          <address class="swiper-slide jiantou">
            <img src="../../static/images/custom_mobile/jiantou.png" />
          </address>
          <address class="swiper-slide">
            <img class="img" src="../../static/images/custom_develop/3a.png" />
            <h4>需求<br />评估</h4>
          </address>
          <address class="swiper-slide jiantou">
            <img src="../../static/images/custom_mobile/jiantou.png" />
          </address>
          <address class="swiper-slide">
            <img class="img" src="../../static/images/custom_develop/4a.png" />
            <h4>需求<br />分析</h4>
          </address>
          <address class="swiper-slide jiantou">
            <img src="../../static/images/custom_mobile/jiantou.png" />
          </address>
          <address class="swiper-slide">
            <img class="img" src="../../static/images/custom_develop/5a.png" />
              <h4>需求<br />评审</h4>
            </address>
            <address class="swiper-slide jiantou">
              <img src="../../static/images/custom_mobile/jiantou.png" />
          </address>
          <address class="swiper-slide">
            <img src="../../static/images/custom_develop/6a.png" />
            <h4>项目<br />设计</h4>
          </address>
          <address class="swiper-slide jiantou">
            <img src="../../static/images/custom_mobile/jiantou.png" />
          </address>
          <address class="swiper-slide">
            <img src="../../static/images/custom_develop/7a.png" />
            <h4>项目<br />开发</h4>
          </address>
          <address class="swiper-slide jiantou">
            <img src="../../static/images/custom_mobile/jiantou.png" />
          </address>
          <address class="swiper-slide">
            <img src="../../static/images/custom_develop/8a.png" />
            <h4>项目<br />反馈</h4>
          </address>
          <address class="swiper-slide jiantou">
            <img src="../../static/images/custom_mobile/jiantou.png" />
          </address>
          <address class="swiper-slide">
            <img src="../../static/images/custom_develop/9a.png" />
            <h4>项目<br />测试</h4>
          </address>
          <address class="swiper-slide jiantou">
            <img src="../../static/images/custom_mobile/jiantou.png" />
          </address>
          <address class="swiper-slide">
            <img src="../../static/images/custom_develop/10a.png" />
            <h4>项目<br />培训</h4>
          </address>
          <address class="swiper-slide jiantou">
            <img src="../../static/images/custom_mobile/jiantou.png" />
          </address>
          <address class="swiper-slide">
            <img src="../../static/images/custom_develop/11a.png" />
            <h4>项目<br />维护</h4>
          </address>
          <!-- <address class="swiper-slide jiantou">
            <img src="../../static/images/custom_mobile/jiantou.png" />
          </address>
          <address class="swiper-slide">
            <img src="../../static/images/custom_develop/12a.png" />
            <h4>项目<br />维护</h4>
          </address> -->
        </div>
      </div>
    </div>
    <div class="custom-advantage">
      <h2>定制优势</h2>
      <div class="advantage-content clearfix">
        <address class="content-item">
          <div class="item-top clearfix">
            <img src="../../static/images/custom_mobile/01.png" />
            <h3>更短开发周期</h3>
            <h4>Shorter period</h4>
          </div>
          <h4 class="item-bottom">
            依托云计算资源定制开发，避免重复造轮子，极大缩短开发时间。云计算时代，如何能有效缩短开发周期呢？深蓝果实云上开发区别于传统软件开发公司，将特有的云上开发模式，依托成熟云产品，节省传统软件开发的大量底层开发周期，助力企业软件、APP、小程序、网站建设快速落地，优质交付。
          </h4>
        </address>
        <address class="content-item">
          <div class="item-top clearfix">
            <img src="../../static/images/custom_mobile/02.png" />
            <h3>更低开发成本</h3>
            <h4>At a low cost</h4>
          </div>
          <h4 class="item-bottom">
            节约大量人力成本、服务器成本和运维成本，实现开发运维低成本。云上开发模式，建立专业的云开发团队，实现开发多角色扮演，让云专家为你节省更多区别于传统开发的人力的成本。
            适用于企业软件开发、APP开发、小程序开发、网站建设等全交付形式的优质开发模式，助力企业实现高效低价开发，优质交付。
          </h4>
        </address>
        <address class="content-item">
          <div class="item-top clearfix">
            <img src="../../static/images/custom_mobile/03.png" />
            <h3>更高产品质量</h3>
            <h4>High quality</h4>
          </div>
          <h4 class="item-bottom">
            依托云平台，产品稳定、快速有效开发，实现高产品质量。云上开发模式建立了软件开发企业适用的全周期质量与过程管理，与云产品本身成熟稳定优势相结合。以面向用户的云产品为质量基准，实现多用户共同把握的高质量产品交付，为企业软件开发、APP开发、小程序开发、网站建设提供可靠的质量保障。
          </h4>
        </address>
        <address class="content-item">
          <div class="item-top clearfix">
            <img src="../../static/images/custom_mobile/04.png" />
            <h3>更好安全性能</h3>
            <h4>More secure</h4>
          </div>
          <h4 class="item-bottom">
            众多用户共同把握产品质量，隔绝隐患，安全性能更好。云上开发模式在原有的软件企业开发模式基础上，提供多维度数据保护，全流程技术支持。云产品、云厂商、市场云产品用户的多维性能维护好及反馈，实现更高安全性能的企业软件开发、APP开发、小程序开发、网站建设模式，
            实现产品的优质交付。
          </h4>
        </address>
      </div>
    </div>
    <div class="custom-promise">
      <h2>我们的承诺</h2>
      <div class="promise-content clearfix">
        <address class="content-item">
          <div class="img">
            <img src="../../static/images/custom_mobile/gou.png" />
          </div>
          <div class="text">
            <h3>量身定制</h3>
            <h4>
              根据您的业务需求和预算，专业产品经理帮您及进行产品规划，打造您的专属APP。
            </h4>
          </div>
        </address>
        <address class="content-item">
          <div class="img">
            <img src="../../static/images/custom_mobile/gou.png" />
          </div>
          <div class="text">
            <h3>私有服务器独立部署</h3>
            <h4>
              根据用户量、并发、计算、存储等情况灵活配置资源，在数据安全、备份等方面有更多选择空间。
            </h4>
          </div>
        </address>
        <address class="content-item">
          <div class="img">
            <img src="../../static/images/custom_mobile/gou.png" />
          </div>
          <div class="text">
            <h3>独享私有安全数据库</h3>
            <h4>
              数据库安全、可靠、合规，系统数据完全私有化，降低了敏感信息泄露的可能性。
            </h4>
          </div>
        </address>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: 'customCenter',
  data() {
    return {
    }
  },
  mounted() {
    var mySwiper = new Swiper('.swiper-container', {
      slidesPerView: 9,
      freeMode: false,
      loop: false,
    });
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
@import '../../../node_modules/swiper/dist/css/swiper.css';

.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

.custom {
  letter-spacing: 1px;
  margin: 0 auto;
  text-align: center;
  font-family: PingFang SC;
}

h2 {
  font-size: 19px;
  font-weight: 800;
}

h4 {
  font-weight: 400;
  font-size: 12px;
  margin-top: 5%;
  line-height: 18px;
}

.custom-framework {
  margin-top: 10%;
  color: #333333;

  .content-item {
    display: inline-block;
    float: left;
    width: 33%;
    margin-top: 5%;
  }
}

.custom-process {
  margin-top: 10%;
  padding: 5% 0;
  background-image: url('../../static/images/custom_mobile/beijing.png');
  color: #FFFFFF;

  .swiper-container {
    margin-top: 5%;

    .swiper-wrapper {
      padding-right:3rem;
      .swiper-slide {
        width: 38px !important;
        h4 {
          opacity: 0.7;
        }
        .img {
          width: 35px;
          height: 35px;
        }
      }

      .jiantou {
        margin-top: 3.5%;
      }

      .swiper-slide:first-child {
        margin-left: 5%;
      }
    }
  }
}

.custom-advantage {
  margin-top: 10%;

  .advantage-content {
    margin-top: 5%;

    .content-item {
      margin: 0 auto;
      margin-bottom: 5%;
      padding: 5% 5%;
      width: 90%;
      height: 100%;
      background: #FFFFFF;
      box-shadow: 0px 3px 15px 0px rgba(111, 111, 111, 0.1);
      box-sizing: border-box;
      text-align: left;

      .item-top {
        img {
          float: left;
          margin-right: 5%;
        }

        h3 {
          width: 60%;
          float: left;
          font-size: 14px;
          line-height: 15px;
          font-weight: bold;
        }

        h4 {
          width: 60%;
          float: left;
          font-size: 14px;
          margin-top: 2%;
          color: #999999;
        }
      }

      .item-bottom {
        color: #666666;
      }
    }
  }
}

.custom-promise {
  margin-top: 10%;
  padding: 5% 0;
  background-color: #FFB400;
  color: #FFFFFF;

  .content-item {
    width: 100%;
    display: inline-block;
    margin-top: 5%;

    .img {
      width: 20%;
      float: left;
    }

    .text {
      width: 75%;
      float: left;
      text-align: left;

      h3 {
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
      }

      h4 {
        margin-top: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/CustomCenter.vue